import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";

export interface DialogProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly title: string;
  readonly description?: string;
  readonly closeLabel: string;
  readonly children: ReactNode;
}

export function Dialog({ open, onOpenChange, title, description, closeLabel, children }: DialogProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 bg-black/40" />
        <DialogPrimitive.Content className="fixed left-1/2 top-1/2 w-[min(92vw,28rem)] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-(--saa-surface) p-6 shadow-lg">
          <DialogPrimitive.Title className="text-lg font-semibold text-(--saa-fg)">{title}</DialogPrimitive.Title>
          {description ? <DialogPrimitive.Description className="mt-1 text-sm text-(--saa-fg-muted)">{description}</DialogPrimitive.Description> : null}
          <div className="mt-4">{children}</div>
          <DialogPrimitive.Close aria-label={closeLabel} className="absolute right-3 top-3 rounded p-1 text-(--saa-fg-muted) hover:bg-(--saa-muted)">
            <X size={16} aria-hidden />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
